/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CaretUp: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M1 17L12 6L23 17' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
  </React.Fragment>
)
